export const isValidDateObj = (d: Date) => {
  return d instanceof Date && !isNaN(d.getDate());
};
